import { render, staticRenderFns } from "./ErrorLogs.vue?vue&type=template&id=0bf2dc3c&"
import script from "./ErrorLogs.vue?vue&type=script&lang=js&"
export * from "./ErrorLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports